<template>
    <!-- TODO-AMAG replace vehicle.fuel.title and duration.title with variables -->
  <div class="px-1">
    <div class="px-3 shadow">

      <!-- Fortschrittsanzeige -->
      <section class="container bg-white px-3 px-md-5">
        <steps
            v-if="steps===4"
            v-bind:current="4"
        ></steps>
        <steps-3
            v-else
            v-bind:current="3"
        ></steps-3>

        <time-box
            :message="$t('subscription.checkout.partials.overviewPartial.nearlyFinishedCheckAgain')"
        ></time-box>
      </section>

    </div>

    <div class="mt-4">
      <mobile-title-separator
          page-link="#step2">
        <h3 class="text-center"><strong>{{ $t('vue.checkout.sidebar.sidebarMobile.overview') }}</strong></h3>
        <h3 class="text-center green-text mb-1"><strong>{{ $t('vue.checkout.sidebar.sidebarMobile.continueWithCheckout') }}</strong></h3>
      </mobile-title-separator>

      <!-- Fahrzeugdetails -->
      <section id="step2" class="container bg-white px-3 px-md-5 py-2">
        <div class="row">
          <div class="col-6">
            <img :src="imageUrl" class="img-fluid">
          </div>
          <div class="col-6">
            <p>
                <strong>
                    {{ $t('vue.checkout.sidebar.vehicleDetails.yourCar') }}
              </strong>
            </p>
            <p>
                {{ vehicle.brand.title }} {{ vehicle.model.title }}<br>
                {{ vehicle.description }}<br>
                {{ $t('vue.checkout.sidebar.sidebarMobile.saleOfferNumber') }} {{ vehicle.id }}
            </p>
          </div>

          <div class="col-12 d-block d-sm-none">
            <ul>
                <li>
                    {{ $t('vue.checkout.sidebar.sidebarMobile.initialRegistration') }} {{ firstRegistration }}
              </li>
              <li>
                  {{ $t('vue.checkout.sidebar.sidebarMobile.drive') }} {{ vehicle.gearshift.title }}
              </li>
              <li>
                  {{ $t('vue.checkout.sidebar.sidebarmobile.engine', {ps:Math.round (vehicle.power_kw * 1.35962) }) }}
              </li>
              <li>
                  {{ $t('vue.checkout.sidebar.sidebarMobile.fuel') }}
                  {{ vehicle.fuel.title }}
              </li>
            </ul>
          </div>

          <div class="col-sm-6 d-none d-sm-block">
            <ul>
                <li>
                    {{ $t('vue.checkout.sidebar.sidebarMobile.initialRegistration') }} {{ firstRegistration }}
              </li>
              <li>
                  {{ $t('vue.checkout.sidebar.sidebarMobile.drive') }} {{ vehicle.gearshift.title }}
              </li>
            </ul>
          </div>

          <div class="col-sm-6 d-none d-sm-block">
            <ul>
                <li>
                    {{ $t('vue.checkout.sidebar.sidebarmobile.engine', {ps:Math.round (vehicle.power_kw * 1.35962) }) }}
              </li>
              <li>
                  {{ $t('vue.checkout.sidebar.sidebarMobile.fuel') }}
                  {{ vehicle.fuel.title }}
              </li>
            </ul>
          </div>

          <div class="col-12">
            <p style="font-size: 0.75rem!important; line-height: 2;">
                <i class="fal fa-check text-success"></i> {{ $t('vue.checkout.sidebar.sidebarMobile.withOutFuel') }}
                <i class="fal fa-check text-success"></i>{{ $t('vue.checkout.sidebar.sidebarMobile.noStartingFees') }}<br>
                <i class="fal fa-check text-success"></i>{{ $t('vue.checkout.sidebar.sidebarMobile.insuranceInclusive') }}
            </p>
          </div>
        </div>
      </section>

      <!-- Km-Paket und Laufzeit -->
      <section class="bg-light p-3 sidebar-sub-container d-flex align-items-stretch">
          <div class="flex-fill">
              <p>
                  <span v-html="$t('vue.checkout.sidebar.sidebarmobile.kmPackage', {mileage: mileage.mileage})">
                  </span><br>
              </p>
          <p>
              <strong>{{ $t('vue.checkout.sidebar.sidebarmobile.minPeriodOfValiity') }} </strong>
              <span v-if="duration.months === 1">{{ $t('consumer.partials.subscriptions.active-table.month', {month: duration.months})}}</span>
              <span v-else>{{ $t('consumer.partials.subscriptions.active-table.months', {months: duration.months})}}</span> <br>
              <i class="fal fa-check text-success"></i>{{ $t('vue.checkout.sidebar.sidebarmobile.terminatable') }}
          </p>
        </div>
      </section>

      <!--
        <mobile-title-separator
                page-link="#step3" id="step3">
            <h3 class="text-center green-text mb-1"><strong>Fahren Sie weiter unten mit dem Checkout fort</strong></h3>
        </mobile-title-separator>
        -->
    </div>
  </div>
</template>

<script>
import PNotify from 'pnotify/dist/es/PNotify';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';

export default {
  name: "SidebarMobile",
  props: {
    currency: {
      type: String,
      default: "€"
    },
    toleranceLimits: {
      type: Array,
      required: true
    },
    steps: {
      type: Number,
      required: true
    },
    vehicle: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    durationOptions: {
      type: Array,
      required: true
    },
    mileageOptions: {
      type: Array,
      required: true
    },
    partner: {
      type: Object,
      required: false
    },
    wrapperClass: {
      type: String,
      required: false
    },
    imageUrl: {
      type: String,
      required: false,
    },
    currentMileage: {
      type: Object,
      required: true
    },
    currentDuration: {
      type: Object,
      required: true
    },
    changeablePricePlans: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selectedMileage: 1,
      selectedDuration: 0,
      ready: false,
      formReady: false,
      blackFaarenWeek: false,
      durations: [],
      defaultDamageParticipation: 1000
    }
  },
  methods: {
    formatPrice (value) {
      let val = (value / 1).toFixed (2).replace ('.', ',');
      return val.toString ().replace (/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    openMileageAndDurationModal () {
      this.formReady = true;
      $ ('#mileageAndDurationModal').modal ('show');
    },
    closeMileageAndDurationModal () {
      $ ('#mileageAndDurationModal').modal ('hide');
    },
    updateSubscription () {
      let self = this;
      axios.patch ('/api/checkout/' + this.subscription.id, {
        identifier: this.subscription.identifier,
        subscription: {
          price: this.price.replace (',', '.'),
          month_id: this.selectedDuration,
          mileage_id: this.selectedMileage
        }
      }).then (r => {
        PNotify.success (r.data.message);
        this.$emit ('subscription-updated');
        self.closeMileageAndDurationModal ();
      }).catch (e => {
        PNotify.alert ("Leider ist ein Fehler aufgetreten. Versuche es später erneut oder wende dich an unseren Support!");
      });
    }
  },
  computed: {
    mileage () {
      return this.subscription.mileage;
    },
    firstRegistration () {
      let date = new Date (this.vehicle.first_registration)

      return date.toLocaleDateString ()
    },
    toleranceLimit () {
      let self = this
      let limit = this.toleranceLimits.find (function (toleranceLimit) {
        return toleranceLimit.mileage === self.subscription.mileage.mileage
      });

      if (limit != null) {
        return limit.pivot.allowed_additional_km
      }
      return "FEHLER"
    },
    duration () {
      return this.subscription.duration;
    },
    price () {
      let prices = this.vehicle.price_calculations;
      let duration = this.durationOptions.find (option => {
        return option.id === this.selectedDuration;
      });
      let mileage = this.mileageOptions.find (option => {
        return option.id === this.selectedMileage;
      });
      return prices.brutto[duration.months][mileage.tag].toFixed (2).replace ('.', ',');
    },
    savings: function () {
      var currentPrice = this.getVehiclePrices ().brutto[this.getCurrentDurationObject ().months][this.currentMileage.tag];

      var shortestDuration = this.durationOptions[0];
      var heighestPrice = this.getVehiclePrices ().brutto[shortestDuration.months][this.currentMileage.tag];

      var savings = heighestPrice - currentPrice;
      return savings.toFixed (0);
    },

    getVehiclePrices () {
      return JSON.parse (this.vehicle.price_calculations);
    },
    getCurrentDurationObject: function () {
      var self = this;
      return this.durationOptions.find (function (option) {
        return option.id === self.selected;
      });
    },
    participation () {
      let damage_participation = this.subscription.damage_participation;

      if (typeof damage_participation === 'undefined' || damage_participation === null) {
        return this.formatPrice (this.defaultDamageParticipation);
      } else {
        return this.formatPrice (damage_participation.participation);
      }
    }
  },
  mounted () {
    if (this.vehicle.category.slug === 'black-faaren-week') {
      this.blackFaarenWeek = true;
      var durationOptionsCopy = JSON.parse (JSON.stringify (this.durationOptions));
      this.durations = durationOptionsCopy.filter (option => option.months == 6);
    } else {
      this.durations = this.durationOptions;
    }

    this.selectedMileage = this.mileage.id;
    this.selectedDuration = this.duration.id;
    this.ready = true;
    axios.get ('/api/damage-participation/default').then (r => {
      this.defaultDamageParticipation = r.data.damage_participation;
    })
  }
}

</script>

<style scoped lang="scss">
$green: #209431;

.green-text {
  color: $green;
}

.modal-trigger {
  cursor: pointer;
}

#mileageAndDurationModal {

  .modal-dialog,
  .modal-content {
    height: 80%;
  }

  .modal-body {
    //max-height: calc(100% - 120px);
    max-height: 100%;
    overflow-y: scroll;
  }
}

h3 {
  font-style: normal;
  font-weight: 700 !important;
  font-size: 1.09rem !important;
  margin-bottom: 0.5rem;
}

p {
  text-align: start !important;
  line-height: 1.3;

  &.small {
    //font-size: 0.8em !important;

  }
}

section {
  &.container {

  }
}
</style>
